export const buildInfo: { gitHash: string; dateTime: number | 'local' } = { gitHash: 'b5143ea', dateTime: 1790287517677 };